"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Paths_1 = require("../constants/Paths");
const LocalStorageKeys_1 = __importDefault(require("../enums/LocalStorageKeys"));
const history_1 = require("../helper/history");
const DID_CLICK_VALUE = new Date().setHours(0, 0, 0, 0).toString();
class AnonymousUserNotice extends react_1.default.Component {
    visible = AuthorizationStore_1.default.user === null &&
        localStorage.getItem(LocalStorageKeys_1.default.anonymousUserNoticeClicked) !== DID_CLICK_VALUE;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            visible: mobx_1.observable,
        });
    }
    render() {
        return (this.visible && (react_1.default.createElement("div", { className: "znd-user-notice" },
            react_1.default.createElement("div", { className: "znd-user-notice-content container p-3" },
                react_1.default.createElement("div", { className: "znd-user-notice__body row" },
                    react_1.default.createElement("div", { className: "znd-user-notice__message col-11 px-4" }, (0, translation_1.t)('user_notice.anonymous.massage')),
                    react_1.default.createElement("div", { className: "znd-user-notice__close row col-1 align-items-start", onClick: () => {
                            localStorage.setItem(LocalStorageKeys_1.default.anonymousUserNoticeClicked, DID_CLICK_VALUE);
                            this.visible = false;
                        } },
                        react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
                react_1.default.createElement("div", { className: "znd-user-notice__actions row" },
                    react_1.default.createElement("div", { className: "col-8 px-4" },
                        react_1.default.createElement(Button_1.default, { className: "znd-user-notice__action-login w-100", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('user_notice.anonymous.action'), icon: Zupicons_1.default.arrowRight, onClick: () => {
                                (0, history_1.pushHistory)(this.props.history, Paths_1.PATH_LOGIN, { returnTo: location.pathname });
                            } })))),
            react_1.default.createElement("div", { className: "znd-user-notice-triangle" }))));
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(AnonymousUserNotice));
